import { render, staticRenderFns } from "./InstaGray.vue?vue&type=template&id=f7fe7508&scoped=true&"
import script from "./InstaGray.vue?vue&type=script&lang=js&"
export * from "./InstaGray.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fe7508",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7fe7508')) {
      api.createRecord('f7fe7508', component.options)
    } else {
      api.reload('f7fe7508', component.options)
    }
    module.hot.accept("./InstaGray.vue?vue&type=template&id=f7fe7508&scoped=true&", function () {
      api.rerender('f7fe7508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/icons/social/InstaGray.vue"
export default component.exports